/******************************************************************************************
 *	IMS Countries and Regions Service
 ********************************************************************************************/
(function () {


  angular.module('rcServices.imsClient', []).service(
    'IMSClient',
    /* @ngInject */
    function (_, binkySrc2, promiseUtils) {
      this.getCountries = function (locale) {
        return promiseUtils.toAngularPromise(
          binkySrc2.api.ims.getCountries(locale)
        ).catch((err) => {
          throw err;
        });
      };

      this.getRegions = function (params) {
        return promiseUtils.toAngularPromise(
          binkySrc2.api.ims.getRegions(params)
        ).catch((err) => {
          throw err;
        });
      };
    }
  );
})();
